// localStorage 中 userId 的有效性判定（AI 发布页 WS 握手参数防护）。
// 历史版本的个人中心曾把接口里不存在的 user_id 字段写入 localStorage，
// 实际存进字符串 "undefined"；AI 页只判断键是否存在会放行该脏值，
// 把 userId=undefined 拼进 WS 地址。统一在此判定，无效时页面改用
// /mine/getMyInfo 重拉（其返回字段为 data.id）覆盖修复。
export function isValidAiUserId(raw) {
  if (typeof raw !== "string") return false;
  const trimmed = raw.trim();
  if (!trimmed) return false;
  const lower = trimmed.toLowerCase();
  return lower !== "undefined" && lower !== "null";
}

export default {
  isValidAiUserId,
};
